<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改客户信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="clientInfo" :rules="rules" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 60px;">客户名称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="clientInfo.name" placeholder="请输入客户名称">
        </Input>
      </FormItem>
      <FormItem prop="phoneNum">
        <label style="display: inline-block; width: 60px;">联系电话</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="clientInfo.phoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <label style="display: inline-block; width: 60px;">联系地址</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="clientInfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'ClientInfoDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '客户名称不能为空', trigger: 'blur' }
        ]
      }
    },
    phoneNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '联系电话不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      modify: false,
      clientInfo: {
        id: null,
        name: null,
        phoneNum: null,
        address: null
      }
    }
  },
  methods: {
    ...mapActions([
      'ClientInfoServ_GetDetail',
      'ClientInfoServ_ModifyObj'
    ]),
    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改客户信息',
          content: '<p>确认修改客户信息</p>',
          onOk: () => {
            store.dispatch('ClientInfoServ_ModifyObj', {
              params: this.clientInfo
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
            let clientInfoId = this._initValue
            store.dispatch('ClientInfoServ_GetDetail', {
              params: { id: clientInfoId }
            }).then(() => {
              this.clientInfo = store.getters.get_ClientInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.id = null
        this.clientInfo.name = null
        this.clientInfo.phoneNum = null
        this.clientInfo.address = null
        let clientInfoId = this._initValue
        if (clientInfoId) {
          store.dispatch('ClientInfoServ_GetDetail', {
            params: { id: clientInfoId }
          }).then(() => {
            this.clientInfo = store.getters.get_ClientInfo_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules,
        phoneNum: this.phoneNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
